import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./CustomModal.css";
import { useDispatch } from "react-redux";
import { newPriceReqSingle } from "../../Actions/ProductDetail/Single";
import api from "../../seller-apis/api";

const MatchPriceModal = ({ show, handleClose, otherPrice, SKU, productId, getProducts, url,receivedFrom }) => {
  const [confirmClicked, setConfirmClicked] = useState(false);
  const dispatch = useDispatch();
  const newPriceReq = () => {
    // document.getElementById("sub_newreq").disabled = true;
    let data = {
      product: productId,
      price: otherPrice,
      sellerPriceReco : true,
      receivedFrom:receivedFrom
    };
    if(url) data['url']=url;

    newPriceReqSingle(dispatch, data);
    setTimeout(() => {
      let data = {
        "_id": productId,
        "vActive": "ACTIVE"
      };
      api.product.addToExProduct(data).then((res) => {
        setConfirmClicked(true);
        getProducts();
      })
      
      
    }, 1000);
    // console.log(state.pStatus);
    // if (state.pPrice < newPrice) {
    //   alert.show("Price request submitted", {
    //     type: "success",
    //   });
    // }

    // if (state.pStatus === "INACTIVE") {
    //   changeinActivetoggle();
    // }
    // handleCloseoffcanverify();
    // handleCloseoffcan();

    // document.getElementById("sub_newreq").disabled = false;
  };
  return (
    <Modal className="custom-modal" centered show={show} onHide={handleClose}>
      <Modal.Body>
        {!confirmClicked ? (
          <>
            <p className="title" style={{fontSize:13}}>
              Do you want to update the price for {SKU} to <i class="fa fa-inr" aria-hidden="true"></i> {otherPrice}?
            </p>
            <div className="action-buttons">
              <Button
                variant="primary"
                className="no-button flex-center"
                onClick={()=>newPriceReq()}
                style={{fontSize:12}}
              >
                Yes
              </Button>
              <Button
                className="yes-button"
                variant="secondary flex-center"
                onClick={handleClose}
                style={{fontSize:12}}
              >
                No
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="title">Price updated succesfully</p>
            <div className="text-center">
              <Button
                variant="primary"
                className="no-button mt-10"
                onClick={()=>handleClose()}
              >
                Ok
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default MatchPriceModal;